import { safeParse, safeParseNullDefault } from 'shouldve-been-js';

class Vessel {

    private _vesselId: number;
    private _sortNo: number | null;
    private _systemCode: string | null;
    private _vesselCode: string | null;
    private _vesselName: string | null;
    private _companyNo: number;
    private _shipNew: string | null;
    private _imoNumber: string | null;
    private _vesselTypeId: string | null;
    private _currCode: string | null;
    private _statusCode: string;
    private _inPurchase: boolean;
    private _inMaintenance: boolean;
    private _inBudget: boolean;
    private _inExperience: boolean;
    private _inVoyage: boolean;
    private _inLogbook: boolean;
    private _inDocking: boolean;

    public constructor(vesselId: number, sortNo: number | null, systemCode: string | null, vesselCode: string | null, vesselName: string | null, companyNo: number, shipNew: string | null, imoNumber: string | null, vesselTypeId: string | null, currCode: string | null, statusCode: string, inPurchase: boolean, inMaintenance: boolean, inBudget: boolean, inExperience: boolean, inVoyage: boolean, inLogbook: boolean, inDocking: boolean) {

        this._vesselId = vesselId;
        this._sortNo = sortNo;
        this._systemCode = systemCode;
        this._vesselCode = vesselCode;
        this._vesselName = vesselName;
        this._companyNo = companyNo;
        this._shipNew = shipNew;
        this._imoNumber = imoNumber;
        this._vesselTypeId = vesselTypeId;
        this._currCode = currCode;
        this._statusCode = statusCode;
        this._inPurchase = inPurchase;
        this._inMaintenance = inMaintenance;
        this._inBudget = inBudget;
        this._inExperience = inExperience;
        this._inVoyage = inVoyage;
        this._inLogbook = inLogbook;
        this._inDocking = inDocking;
    }

    public get vesselId(): number {
        return this._vesselId;
    }

    public set vesselId(value: number) {
        this._vesselId = value;
    }

    public get sortNo(): number | null {
        return this._sortNo;
    }

    public set sortNo(value: number | null) {
        this._sortNo = value;
    }

    public get systemCode(): string | null {
        return this._systemCode;
    }

    public set systemCode(value: string | null) {
        this._systemCode = value;
    }

    public get vesselCode(): string | null {
        return this._vesselCode;
    }

    public set vesselCode(value: string | null) {
        this._vesselCode = value;
    }

    public get vesselName(): string | null {
        return this._vesselName;
    }

    public set vesselName(value: string | null) {
        this._vesselName = value;
    }

    public get companyNo(): number {
        return this._companyNo;
    }

    public set companyNo(value: number) {
        this._companyNo = value;
    }

    public get shipNew(): string | null {
        return this._shipNew;
    }

    public set shipNew(value: string | null) {
        this._shipNew = value;
    }

    public get imoNumber(): string | null {
        return this._imoNumber;
    }

    public set imoNumber(value: string | null) {
        this._imoNumber = value;
    }

    public get vesselTypeId(): string | null {
        return this._vesselTypeId;
    }

    public set vesselTypeId(value: string | null) {
        this._vesselTypeId = value;
    }

    public get currCode(): string | null {
        return this._currCode;
    }

    public set currCode(value: string | null) {
        this._currCode = value;
    }
    
    public get statusCode(): string {
        return this._statusCode;
    }

    public set statusCode(value: string) {
        this._statusCode = value;
    }

    public get inPurchase(): boolean {
        return this._inPurchase;
    }

    public set inPurchase(value: boolean) {
        this._inPurchase = value;
    }

    public get inMaintenance(): boolean {
        return this._inMaintenance;
    }

    public set inMaintenance(value: boolean) {
        this._inMaintenance = value;
    }

    public get inBudget(): boolean {
        return this._inBudget;
    }

    public set inBudget(value: boolean) {
        this._inBudget = value;
    }

    public get inExperience(): boolean {
        return this._inExperience;
    }

    public set inExperience(value: boolean) {
        this._inExperience = value;
    }

    public get inVoyage(): boolean {
        return this._inVoyage;
    }

    public set inVoyage(value: boolean) {
        this._inVoyage = value;
    }

    public get inLogbook(): boolean {
        return this._inLogbook;
    }

    public set inLogbook(value: boolean) {
        this._inLogbook = value;
    }

    public get inDocking(): boolean {
        return this._inDocking;
    }

    public set inDocking(value: boolean) {
        this._inDocking = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Vessel | null {

        const vesselId: number | null = safeParseNullDefault<number>(json?.vesselId, 0);
        const sortNo: number | null = safeParseNullDefault<number>(json?.sortNo, 0);
        const systemCode: string | null = safeParseNullDefault<string>(json?.systemCode, '');
        const vesselCode: string | null = safeParseNullDefault<string>(json?.vesselCode, '');
        const vesselName: string | null = safeParseNullDefault<string>(json?.vesselName, '');
        const companyNo: number = safeParse<number>(json?.companyNo, 0);
        const shipNew: string | null = safeParseNullDefault<string>(json?.shipNew, '');
        const imoNumber: string | null = safeParseNullDefault<string>(json?.imoNumber, '');
        const vesselTypeId: string | null = safeParseNullDefault<string>(json?.vesselTypeId, '');
        const currCode: string | null = safeParseNullDefault<string>(json?.currCode, '');
        const statusCode: string | null = safeParseNullDefault<string>(json?.statusCode, '');
        const inPurchase: boolean = safeParse<boolean>(json?.inPurchase, false);
        const inMaintenance: boolean = safeParse<boolean>(json?.inMaintenance, false);
        const inBudget: boolean = safeParse<boolean>(json?.inBudget, false);
        const inExperience: boolean = safeParse<boolean>(json?.inExperience, false);
        const inVoyage: boolean = safeParse<boolean>(json?.inVoyage, false);
        const inLogbook: boolean = safeParse<boolean>(json?.inLogbook, false);
        const inDocking: boolean = safeParse<boolean>(json?.inDocking, false);

        if (vesselId === null || statusCode === null) {
            return null;
        }
        
        return new Vessel(vesselId, sortNo, systemCode, vesselCode, vesselName, companyNo, shipNew, imoNumber, vesselTypeId, currCode, statusCode, inPurchase, inMaintenance, inBudget, inExperience, inVoyage, inLogbook, inDocking);
    }
}

export default Vessel;